import { InduccionEstado } from "../common/enumModel";

export class FilterInduccionesPorPersonaModel {
    nombreEmpleado: string;
    nroDocumentoIdentidad: string;
    codigoSolicitud: string;
    solicitante: string;

    sedes: number[];

    fechaInicioInduccion?: Date;
    fechaFinInduccion?: Date;

    idEstado: InduccionEstado;
    estados: number[];

    nombreContratista: string;
    nombreCapacitador:string;
    page: number;
    pageSize: number;
    idCompania: number;

    constructor() {
        this.nombreEmpleado = '';
        this.nroDocumentoIdentidad = '';
        this.codigoSolicitud = '';
        this.solicitante = '';
        this.sedes = [];
        this.solicitante = '';

        this.idEstado = InduccionEstado.EMPTY;
        this.estados = [];

        this.nombreContratista = '';
        this.nombreCapacitador = '';

        this.page = 1;
        this.pageSize = 30;
        this.idCompania = 0;
    }
}